const endodontics = {
  hero: {
    badgeIconAlt: "Endodontics Icon",
    badgeText: "Fortschrittliche Wurzelkanalbehandlungen",
    titleLine1: "Moderne Endodontische",
    titleLine2: "Pflege & Behandlung",
    description:
      "Unsere kompetenten endodontischen Behandlungen retten Ihre natürlichen Zähne durch fortschrittliche, schmerzminimierte Wurzelkanalverfahren unter Verwendung neuester Technologie und Techniken.",
    ctas: {
      primary: "Beratungstermin vereinbaren",
      secondary: "Mehr über den Prozess erfahren",
    },
    heroImageAlt: "Modern Endodontic Treatment",
    stats: {
      successRateLabel: "Erfolgsquote",
      successRateValue: "95%+",
      painFreeLabel: "Schmerzfrei",
      painFreeValue: "Fortschrittlich",
    },
    experience: {
      label: "Erfahrene Spezialisten",
      value: "15+ Jahre Erfahrung",
    },
  },
  benefits: {
    heading: "WARUM EINE WURZELBEHANDLUNG WÄHLEN",
    intro:
      "Moderne Wurzelkanaltherapie erhält Ihre natürlichen Zähne mit Komfort und Präzision.",
    items: [
      {
        title: "Retten Sie Ihre natürlichen Zähne",
        description:
          "Eine endodontische Behandlung hilft Ihnen, Ihr natürliches Lächeln zu bewahren, weiterhin Ihre Lieblingsspeisen zu genießen und begrenzt die Notwendigkeit fortlaufender zahnärztlicher Arbeiten.",
      },
      {
        title: "So gut wie schmerzfrei",
        description:
          "Dank moderner Techniken und Anästhesie berichten Patienten, dass eine Wurzelbehandlung genauso angenehm ist wie das Legen einer Füllung.",
      },
      {
        title: "Effizient & Effektiv",
        description:
          "Unsere endodontischen Verfahren werden in nur 1-2 Terminen abgeschlossen und bieten schnelle Schmerzlinderung mit hervorragenden Langzeitergebnissen.",
      },
    ],
  },
  process: {
    heading: "UNSER BEHANDLUNGSPROZESS",
    intro:
      "Wir folgen einem präzisen, methodischen Ansatz, um die bestmöglichen Ergebnisse für unsere endodontischen Behandlungen sicherzustellen.",
    steps: [
      {
        title: "Diagnose & Untersuchung",
        description:
          "Unsere Spezialisten machen digitale Röntgenaufnahmen und führen Tests durch, um die Ursache Ihrer Schmerzen zu identifizieren und festzustellen, ob eine Wurzelbehandlung notwendig ist.",
      },
      {
        title: "Vorbereitung & Anästhesie",
        description:
          "Wir verabreichen eine lokale Betäubung, um den Bereich vollständig zu betäuben, damit Sie während des Eingriffs keine Schmerzen spüren.",
      },
      {
        title: "Entfernung der Pulpa & Reinigung",
        description:
          "Der infizierte Zahnnerv (Pulpa) wird sorgfältig entfernt und die Kanäle werden mit speziellen Instrumenten gründlich gereinigt und geformt.",
      },
      {
        title: "Füllung & Versiegelung der Kanäle",
        description:
          "Die gereinigten Kanäle werden mit biokompatiblem Material gefüllt und versiegelt, um eine erneute Infektion zu verhindern.",
      },
      {
        title: "Endgültige Versorgung",
        description:
          "Eine Krone oder eine andere Restauration wird eingesetzt, um den Zahn zu schützen und seine volle Funktion und sein Aussehen wiederherzustellen.",
      },
    ],
  },
  faq: {
    heading: "HÄUFIG GESTELLTE FRAGEN",
    intro:
      "Finden Sie Antworten auf häufige Fragen zu endodontischen Behandlungen",
    items: [
      {
        question: "Ist eine Wurzelbehandlung schmerzhaft?",
        answer:
          "Mit modernen Techniken und Anästhesie fühlt sich eine Wurzelbehandlung ähnlich an wie das Bekommen einer Füllung. Die meisten Patienten berichten, dass sie sich während des Eingriffs wohl fühlen und danach nur leichte Beschwerden haben, die mit rezeptfreien Schmerzmitteln behandelt werden können.",
      },
      {
        question: "Wie lange dauert eine Wurzelbehandlung?",
        answer:
          "Die meisten Wurzelbehandlungen können in einem einzigen Termin von 60-90 Minuten abgeschlossen werden. Komplexere Fälle erfordern möglicherweise zwei Besuche. Unser Einsatz fortschrittlicher Technologie trägt dazu bei, Effizienz zu gewährleisten, ohne die Qualität zu beeinträchtigen.",
      },
      {
        question: "Wie lange hält ein behandelter Zahn?",
        answer:
          "Bei richtiger Pflege kann ein Zahn, der wurzelbehandelt wurde, ein Leben lang halten. Die Erfolgsquote von Wurzelbehandlungen ist sehr hoch, und viele Zähne, die mit Wurzelbehandlungen repariert wurden, können so lange halten wie andere natürliche Zähne.",
      },
      {
        question: "Was passiert, wenn ich keine Wurzelbehandlung durchführen lasse?",
        answer:
          "Wenn Sie eine Wurzelbehandlung benötigen, diese aber nicht durchführen lassen, wird sich die Infektion weiter ausbreiten, was möglicherweise zur Bildung von Abszessen, Knochenabbau und schließlich zum Zahnverlust führt. Die Infektion kann sich auch auf andere Teile Ihres Körpers ausbreiten und ernsthafte Gesundheitsrisiken darstellen.",
      },
      {
        question: "Brauche ich nach einer Wurzelbehandlung eine Krone?",
        answer:
          "In den meisten Fällen ja. Eine Krone hilft, den behandelten Zahn vor Brüchen zu schützen und stellt die volle Funktionsfähigkeit wieder her. Backenzähne (Molaren und Prämolaren) benötigen fast immer Kronen, während Frontzähne dies möglicherweise nicht benötigen, wenn sie noch strukturell intakt sind.",
      },
      {
        question: "Wie pflege ich meinen Zahn nach einer Wurzelbehandlung?",
        answer:
          "Nachdem Ihre endgültige Restauration eingesetzt wurde, sollten Sie Ihren behandelten Zahn genauso pflegen wie Ihre natürlichen Zähne: zweimal täglich putzen, täglich Zahnseide verwenden, antimikrobielle Mundspülung benutzen und regelmäßig Ihren Zahnarzt für Kontrollen und Reinigungen aufsuchen.",
      },
    ],
  },
};

export default endodontics;

